<template>
  <div class="supplierSettlement_box">
    <!--头部区域-->
    <div class="supplierSettlement_header">
      <div class="supplierSettlement_header_box">
        <div class="flex align-items-end">
          <a class="logo-box" :href="toIndex" target="_blank">
            <img :src="logoUrl" class="cursor" width="210" height="22" style="vertical-align: middle" :alt="$t('key1000009')">
            <p class="logo-sub-desc">{{ $t('key1000083') }}</p>
          </a>
          <h2 class="supplier_title">{{ $t('key1000072') }}</h2>
        </div>
        <p class="flex align-items-center cursor">
          <span class="mr10">{{ $t('key1006519') }}</span>
          <a class="distributorThemeColor" :href="toSupplier" target="_blank">{{ $t('key1006520') }}</a>
        </p>
      </div>
    </div>
    <!--主体内容-->
    <div class="supplierSettlement_content">
      <!--步骤条-->
      <Steps :current="current">
        <Step :title="$t('key1006515')"></Step>
        <Step :title="$t('key1006516')"></Step>
        <Step :title="$t('key1006517')"></Step>
        <Step :title="$t('key1006518')"></Step>
      </Steps>
      <!--填写账号信息-->
      <supplierEntryInfo v-if="current === 0" @registerSuccess="registerSuccessBtn"></supplierEntryInfo>
      <!--填写企业信息-->
      <supplierEnterpriseInfo
        :supplierEnterpriseType="supplierEnterpriseType"
        v-if="current === 1"
        :supplierInfo="supplierInfo"
        @submittedSuccess="submittedSuccessBtn">
      </supplierEnterpriseInfo>
      <!--入驻资料审核-->
      <div class="submittedSuccess_box" v-if="current ===2">
        <!--提交成功-->
        <template v-if="enterpriseInfoSuccess">
          <Icon type="md-checkmark-circle" size="40" color="#FE5426"/>
          <h2 class="font-size-17 font-weight-bold color-333 mt15 mb5">{{ $t('key1006521') }}</h2>
          <p class="font-size-14 color-666">{{ $t('key1006522') }}<br/>{{ $t('key1006523') }}<br/>{{ $t('key1006524') }}
          </p>
        </template>
        <!--审核通过-->
        <template v-if="supplierInfo.supplierAuditStatus === 1">
          <span class="iconfont_styles"><i class="icon iconfont">&#xe6a7;</i></span>
          <h2 class="font-size-17 font-weight-bold color-333 mt15 mb5">{{ $t('key1006525') }}</h2>
          <p class="font-size-14 color-666">{{ $t('key1006526') }}<br/>{{ $t('key1006527') }}</p>
        </template>
        <!--审核不通过-->
        <template v-if="supplierInfo.supplierAuditStatus === 0">
          <Icon type="md-close-circle" size="40" color="#FE5426"/>
          <h2 class="font-size-17 font-weight-bold color-333 mt15 mb5">{{ $t('key1006528') }}</h2>
          <p class="font-size-14 color-666">{{ $t('key1006529') }}</p>
          <div class="auditRemarks_style" v-html="supplierInfo.auditRemarks"></div>
          <Button type="primary" class="mt30" @click="reviseBtn">{{ $t('key1006530') }}</Button>
        </template>
      </div>
      <!--注册成功-->
      <div class="registerSuccess_box" v-if="current === 3">
        <Icon type="md-checkmark-circle" size="40" color="#FE5426"/>
        <h2 class="font-size-17 font-weight-bold color-333 mt15 mb5">{{ $t('key1006531') }}</h2>
        <p class="font-size-14 color-666">{{ $t('key1006532') }}</p>
        <a :href="toProductGoods">
          <Button type="primary" class="mt20">{{ $t('key1006533') }}</Button>
        </a>
      </div>
    </div>
    <!--底部区域-->
    <shop-footer :footerLogo="false" footerTheme="light"></shop-footer>
  </div>
</template>

<script>
import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import shopFooter from "@/components/layout/shopping/footer.vue";
import supplierEntryInfo from "@/views/shopping/login/components/supplierEntryInfo.vue";
import supplierEnterpriseInfo from "@/views/shopping/login/components/supplierEnterpriseInfo.vue";
import {getHrefPath, crossSystemJumpLink, handleLogoUrl, _handleMultilingualFields} from "@/utils/common";

export default {
  name: "supplierSettlement",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      current: 0,
      auditStatus: 0, // 审核状态
      supplierInfo: {},
      supplierEnterpriseType: 'add',
      enterpriseInfoSuccess: false
    };
  },
  computed: {
    // 跳转到商城首页
    toIndex() {
      let url = '/index.html#/index';
      let service = '/yms-shopping-service';
      return getHrefPath(url, service);
    },
    // 跳转到供应商系统首页
    toSupplier() {
      let url = '/yms-supplier-service/supplier.html#/statistics';
      let system = 'supplier';
      return crossSystemJumpLink(url, system);
    },
    // 跳转到供应商系统--商品管理
    toProductGoods() {
      let url = '/yms-supplier-service/supplier.html#/productCenter/productGoods';
      let system = 'supplier';
      return crossSystemJumpLink(url, system);
    },
    // logo图
    logoUrl() {
      return handleLogoUrl();
    },
  },
  async created() {
    await this.$loadProjectTheme();
    let supplierMerchantId = this.$route.query.supplierMerchantId || null;
    this.getSupplierInfo(supplierMerchantId);
  },
  methods: {
    // 获取供应商基本信息数据
    getSupplierInfo(supplierMerchantId) {
      let v = this;
      if (supplierMerchantId) {
        v.axios.get(api.get_ymsSupplierMerchant + supplierMerchantId).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              /*
                * supplierRegisterStatus：供应商注册流转状态: 1.账号信息注册完成准备填写企业信息、2.企业信息注册完成准备审核、3.入驻资料审核完成并注册成功
                * supplierAuditStatus：供应商审核状态 0审核不通过、1待审核、2审核通过
              */
              let newData = data.ymsSupplierMerchantDetail || {};
              newData.name = _handleMultilingualFields(data.name);
              newData = Object.assign({}, data, newData);
              if (newData.auditRemarks) {
                v.supplierInfo.auditRemarks = newData.auditRemarks.replace(/\n/g, "<br>");
              }

              if (newData.supplierAuditStatus === 2) {
                v.current = 3;
              } else {
                if (newData.supplierRegisterStatus === 3) {
                  v.current = 2;
                } else {
                  v.current = newData.supplierRegisterStatus;
                }
              }
              v.supplierInfo = newData;
            }
          }
        });
      }
    },
    // 填写账号信息成功之后
    registerSuccessBtn(data) {
      let merchantId = data || this.$route.query.supplierMerchantId || this.supplierInfo.ymsMerchantId;
      this.$router.push({
        path: '/supplierSettlement',
        query: {
          supplierMerchantId: merchantId
        }
      });
      this.getSupplierInfo(merchantId);
    },
    // 填写企业信息成功之后
    submittedSuccessBtn(val) {
      this.current = val;
      this.enterpriseInfoSuccess = true;
    },
    // 重新修改--(回退到填写企业信息节点)
    reviseBtn() {
      this.supplierEnterpriseType = 'edit';
      this.supplierInfo.supplierAuditStatus = null;
      this.current = 1;
    }
  },
  components: {
    shopFooter,
    supplierEntryInfo,
    supplierEnterpriseInfo
  },
};
</script>

<style lang="less" scoped>
.supplierSettlement_box {
  width: 100%;
  height: 100vh;

  .supplierSettlement_header {
    border-bottom: 1px solid #D7D7D7;
    box-sizing: border-box;

    .supplierSettlement_header_box {
      width: 1200px;
      margin: 0 auto;
      padding: 15px 0 10px 0;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }

    .logo-box {
      .logo-sub-desc {
        color: #3333337f;
        font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        margin-top: 4px;
        font-size: 14px;
        width: 210px;
        text-align: center;
      }
    }

    .supplier_title {
      font-size: 17px;
      font-weight: bold;
      color: #000;
      margin-left: 20px;
    }
  }

  .supplierSettlement_content {
    width: 1200px;
    margin: 60px auto;

    /deep/ .ivu-steps {
      padding-left: 30px;

      .ivu-steps-item {
        overflow: initial;

        .ivu-steps-title {
          display: block;
          margin-top: 8px;
          position: relative;
          left: -28px;
        }

        &:last-child {
          .ivu-steps-title {
            left: -14px;
          }
        }

        .ivu-icon-ios-checkmark {
          color: #fff;
          background: #FD5425;
          border-radius: 50%;
          overflow: hidden;
        }
      }
    }

  }

  .submittedSuccess_box, .registerSuccess_box {
    width: 300px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 100px auto 100px;
    text-align: center;

    .iconfont_styles {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #FE5426;
      display: flex;
      justify-content: center;
      align-items: center;

      .iconfont {
        color: #FE5426;
        font-size: 38px;
      }
    }

    .auditRemarks_style {
      margin-top: 25px;
      width: 250px;
      text-align: left;
      line-height: 24px;
      color: #000;
      font-weight: bold;
    }
  }
}
</style>